function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var UNAUTHORIZED_ERROR_MESSAGE = "You must be logged in to access this resource";
var FORBIDDEN_ERROR_MESSAGE = "You don't have permission to access this resource";
var NOT_FOUND_ERROR_MESSAGE = "The resource you were looking for could not be found";
var DEFAULT_ERROR_MESSAGE = "There was an unexpected problem";
/**
 * Utility for generating generic error messages for API errors.
 *
 * @author @jchaiken1
 */ var GenericErrorMessageUtil = /*#__PURE__*/ function() {
    "use strict";
    function GenericErrorMessageUtil() {
        _class_call_check(this, GenericErrorMessageUtil);
    }
    _create_class(GenericErrorMessageUtil, null, [
        {
            key: "generateErrorMessage",
            value: function generateErrorMessage(error) {
                return this.forStatusCode(error.httpStatus);
            }
        },
        {
            key: "forWindmillError",
            value: function forWindmillError(error) {
                return this.forStatusCode(error.httpStatus);
            }
        },
        {
            key: "forStatusCode",
            value: function forStatusCode(statusCode) {
                switch(statusCode){
                    case 401:
                        return UNAUTHORIZED_ERROR_MESSAGE;
                    case 403:
                        return FORBIDDEN_ERROR_MESSAGE;
                    case 404:
                        return NOT_FOUND_ERROR_MESSAGE;
                    default:
                        return DEFAULT_ERROR_MESSAGE;
                }
            }
        }
    ]);
    return GenericErrorMessageUtil;
}();
export default GenericErrorMessageUtil;
